// extracted by mini-css-extract-plugin
module.exports = {"tail":"dh-dh-klima-spesial-english-tail--9fd966860ac9348f8c573c3e2cb4e524"};